<template>
  <div class="dromo-test chemtracker-module">
    <div>
      <VActionButton
        :show-badge="false"
        :show-icon="false"
        label="Test import"
        @click="startImport"
      />
    </div>
    <div class="data">Data: {{ dromoResultsData }}</div>
    <div class="metadata">Metadata: {{ dromoResultsMetadata }}</div>
  </div>
</template>

<script>
import { useDromo } from "@/composables/useDromo";
import VActionButton from "../raft/VActionButton.vue";

export default {
  name: "DromoTestPage",
  components: {
    VActionButton,
  },
  setup() {
    const { dromo, dromoResultsData, dromoResultsMetadata } = useDromo();
    return {
      dromo,
      dromoResultsData,
      dromoResultsMetadata,
    };
  },
  methods: {
    startImport() {
      this.dromo.open();
    },
  },
};
</script>

<style scoped>
.data,
.metadata {
  margin: 1rem 0;
}
</style>
